import { useMemo } from 'react'
import { TYPEAHEAD_SUGGESTION_ROLLOUT_FLAGS } from 'constants/search'
import { EmptyArray } from 'lib/array/arrayUtils'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

/**
 * Builds the typeahead rollout flags array from feature flags that gate optional
 * backend behaviour. Reads Optimizely flags internally so callers don't need to
 * manage them. Returns a stable EmptyArray reference when no flags are active.
 */
function useTypeaheadRollout(): Array<string> {
  const isTypeaheadSuggestionEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.searchTypeaheadSuggestion)
  return useMemo(() => {
    const flags: Array<string> = [
      ...(isTypeaheadSuggestionEnabled ? TYPEAHEAD_SUGGESTION_ROLLOUT_FLAGS : []),
    ]
    return flags.length > 0 ? flags : EmptyArray
  }, [isTypeaheadSuggestionEnabled])
}

export default useTypeaheadRollout
